export default __webpack_public_path__ + "static/media/spark_54.ccb52edb.png";